const headingTheme = {
  baseStyle: {
    fontFamily: 'GTWalsheimPro',
  },
};

export default headingTheme;
